<template>
  <div class="captcha"></div>
</template>
<script src="../ct4.js"></script>
<script>
export default {
  name: "AliCaptcha",
  props: ["captchaConfig"],
  mounted() {
    initAlicom4(this.captchaConfig.config, this.captchaConfig.handler);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AliCaptcha.vue